
export default class MonsterDescription {
    /**
     * @param {string} id 
     * @param {string} spriteName 
     * @param {string} brainId
     */
    constructor(id, spriteName, brainId) {
        /**
         * @constant
         * @type {string}
         */
        this.id = id;
        /**
         * @constant
         * @type {string}
         */
        this.spriteName = spriteName;
        /**
         * @constant
         * @type {string}
         */
        this.brainId = brainId;
    }   

}